import { render, staticRenderFns } from "./permissions-header.vue?vue&type=template&id=79cb1e4e&scoped=true&"
var script = {}
import style0 from "./permissions-header.vue?vue&type=style&index=0&id=79cb1e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cb1e4e",
  null
  
)

export default component.exports